/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Flow_Step2_DescInputs */

const en_directory_submit_flow_step2_desc = /** @type {(inputs: Directory_Submit_Flow_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional — unlocks dofollow`)
};

const zh_directory_submit_flow_step2_desc = /** @type {(inputs: Directory_Submit_Flow_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可选 — 解锁 dofollow`)
};

/**
* | output |
* | --- |
* | "Optional — unlocks dofollow" |
*
* @param {Directory_Submit_Flow_Step2_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_flow_step2_desc = /** @type {((inputs?: Directory_Submit_Flow_Step2_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Flow_Step2_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_flow_step2_desc(inputs)
	return zh_directory_submit_flow_step2_desc(inputs)
});
export { directory_submit_flow_step2_desc as "directory.submit.flow.step2_desc" }